import { IDocumentTypeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetDocumentTypeUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IDocumentTypeRepositoryResponse> {
    return this.lookupRepository.getDocumentTypes();
  }
}
